const FormResult = ({ result }) => {
  return <>
    {result !== null && <div className={`m-1 ${result.success ? 'field-success' : 'field-error'}`}>{Array.isArray(result.message) ? result.message.map(msg => <p className={'mb-0'}>{msg}</p>) : result.message}</div>}
  </>
}

export default FormResult